(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["expandable-description"] && !Shopify.designMode) return;
  try {
    (() => {
    const initDescription = (desc) => {
      if (desc.dataset.readMoreInit) return;
      desc.dataset.readMoreInit = 'true';

      const children = Array.from(desc.children);
      if (!children.length) return;

      let cutIndex = 1;
      const first = children[0];
      const firstIsEyebrow =
        first.tagName === 'P' &&
        first.children.length === 1 &&
        first.children[0].tagName === 'STRONG' &&
        first.textContent.trim() === first.children[0].textContent.trim();
      if (firstIsEyebrow && children.length > 1) cutIndex = 2;

      const rest = children.slice(cutIndex);
      if (!rest.length) return;

      const collapse = document.createElement('div');
      collapse.className = 'expandable-description__more-collapse';
      const inner = document.createElement('div');
      inner.className = 'expandable-description__more-inner';
      rest.forEach((el) => inner.appendChild(el));
      collapse.appendChild(inner);
      desc.appendChild(collapse);

      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'expandable-description__toggle';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.innerHTML =
        '<span data-toggle-label></span>' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>';
      toggle.querySelector('[data-toggle-label]').textContent = desc.dataset.readMoreLabel;
      desc.insertAdjacentElement('afterend', toggle);

      toggle.addEventListener('click', () => {
        const expanded = collapse.classList.toggle('is-expanded');
        toggle.classList.toggle('is-expanded', expanded);
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        toggle.querySelector('[data-toggle-label]').textContent = expanded
          ? desc.dataset.readLessLabel
          : desc.dataset.readMoreLabel;
      });
    };

    document.querySelectorAll('[data-expandable-description]').forEach(initDescription);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    const addToCart = async (variantId, quantity) => {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
    });
    if (!res.ok) throw new Error('cart add failed');
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  };

  document.addEventListener('click', async (e) => {
    const quickBtn = e.target.closest('[data-card-quick-add]');
    if (!quickBtn || quickBtn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    const variantId = parseInt(quickBtn.dataset.variantId, 10);
    if (!variantId) return;
    quickBtn.disabled = true;
    const img = quickBtn.closest('.product-card').querySelector('.product-card__media img');
    document.dispatchEvent(new CustomEvent('cart:fly', { detail: { sourceEl: img } }));
    try {
      await addToCart(variantId, 1);
      quickBtn.classList.add('is-added');
      setTimeout(() => quickBtn.classList.remove('is-added'), 2200);
    } catch (err) {}
    quickBtn.disabled = false;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-carousel"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-product-carousel]').forEach((section) => {
    const track = section.querySelector('[data-carousel-track]');
    const prevBtn = section.querySelector('[data-carousel-prev]');
    const nextBtn = section.querySelector('[data-carousel-next]');
    if (!track) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const SPEED = 34; // px per second

    let half = 0;
    const measure = () => {
      half = track.scrollWidth / 2;
    };
    measure();
    window.addEventListener('resize', measure);

    const normalize = () => {
      if (!half) return;
      if (track.scrollLeft >= half) {
        track.scrollLeft -= half;
      } else if (track.scrollLeft <= 0) {
        track.scrollLeft += half;
      }
    };

    const cardStep = () => {
      const card = track.querySelector('.carousel-card');
      if (!card) return 300;
      const style = getComputedStyle(track);
      const gap = parseFloat(style.columnGap || style.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    };

    let paused = false;
    let resumeTimer = null;
    const go = (dir) => {
      paused = true;
      clearTimeout(resumeTimer);
      track.scrollBy({ left: dir * cardStep(), behavior: 'smooth' });
      resumeTimer = setTimeout(() => {
        paused = false;
      }, 3200);
    };

    if (prevBtn) prevBtn.addEventListener('click', () => go(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => go(1));

    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        go(1);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        go(-1);
      }
    });

    track.addEventListener('pointerenter', () => {
      paused = true;
      clearTimeout(resumeTimer);
    });
    track.addEventListener('pointerleave', () => {
      paused = false;
    });
    track.addEventListener('focusin', () => {
      paused = true;
      clearTimeout(resumeTimer);
    });
    track.addEventListener('focusout', () => {
      paused = false;
    });
    track.addEventListener('scroll', normalize, { passive: true });

    let lastT = performance.now();
    const tick = (now) => {
      requestAnimationFrame(tick);
      const dt = Math.min((now - lastT) / 1000, 0.1);
      lastT = now;
      if (!paused && !reducedMotion.matches) {
        track.scrollLeft += SPEED * dt;
        normalize();
      }
    };
    requestAnimationFrame(tick);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    const isThumbMode = (gallery) => gallery.classList.contains('product-gallery--with-thumbs');
    const getSlides = (gallery) => [...gallery.querySelectorAll('[data-gallery-slide]')];
    const getThumbs = (gallery) => [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const getDots = (gallery) => [...gallery.querySelectorAll('[data-gallery-dot]')];

    const scrollToSlide = (track, index) => {
      const slide = track.children[index];
      if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    };

    const scrollIndexOf = (track) => {
      const slides = [...track.children];
      let closest = 0;
      let min = Infinity;
      slides.forEach((s, i) => {
        const d = Math.abs(s.offsetLeft - track.scrollLeft);
        if (d < min) {
          min = d;
          closest = i;
        }
      });
      return closest;
    };

    const fadeIndexOf = (gallery) => {
      const idx = getSlides(gallery).findIndex((s) => s.classList.contains('is-active'));
      return idx === -1 ? 0 : idx;
    };

    const currentIndex = (gallery) => {
      if (isThumbMode(gallery)) return fadeIndexOf(gallery);
      const track = gallery.querySelector('[data-gallery-track]');
      return track ? scrollIndexOf(track) : 0;
    };

    const slideCount = (gallery) => getSlides(gallery).length;

    const goTo = (gallery, index) => {
      const max = slideCount(gallery) - 1;
      const clamped = Math.max(0, Math.min(max, index));
      if (isThumbMode(gallery)) {
        const slides = getSlides(gallery);
        const thumbs = getThumbs(gallery);
        slides.forEach((s, i) => s.classList.toggle('is-active', i === clamped));
        thumbs.forEach((t, i) => t.classList.toggle('is-active', i === clamped));
        const activeThumb = thumbs[clamped];
        const thumbsContainer = activeThumb && activeThumb.parentElement;
        if (thumbsContainer) {
          if (thumbsContainer.scrollWidth > thumbsContainer.clientWidth) {
            const left = activeThumb.offsetLeft - (thumbsContainer.clientWidth - activeThumb.clientWidth) / 2;
            thumbsContainer.scrollTo({ left, behavior: 'smooth' });
          } else if (thumbsContainer.scrollHeight > thumbsContainer.clientHeight) {
            const top = activeThumb.offsetTop - (thumbsContainer.clientHeight - activeThumb.clientHeight) / 2;
            thumbsContainer.scrollTo({ top, behavior: 'smooth' });
          }
        }
      } else {
        const track = gallery.querySelector('[data-gallery-track]');
        if (track) scrollToSlide(track, clamped);
      }
      gallery.dispatchEvent(new CustomEvent('gallery:change', { detail: { index: clamped } }));
    };

    const autoplayState = new WeakMap();

    const stopAutoplay = (gallery) => {
      const state = autoplayState.get(gallery);
      if (state && state.timer) {
        clearTimeout(state.timer);
        state.timer = null;
      }
    };

    const startAutoplay = (gallery) => {
      if (!gallery.hasAttribute('data-gallery-autoplay') || slideCount(gallery) < 2) return;
      stopAutoplay(gallery);
      const defaultInterval = Number(gallery.dataset.galleryInterval) || 3800;
      const slides = getSlides(gallery);
      const activeSlide = slides[currentIndex(gallery)];
      const duration = (activeSlide && Number(activeSlide.dataset.slideDuration)) || defaultInterval;
      const state = autoplayState.get(gallery) || {};
      state.timer = setTimeout(() => {
        const max = slideCount(gallery) - 1;
        const next = currentIndex(gallery) >= max ? 0 : currentIndex(gallery) + 1;
        goTo(gallery, next);
        startAutoplay(gallery);
      }, duration);
      autoplayState.set(gallery, state);
    };

    const restartAutoplayLater = (gallery) => {
      if (!gallery.hasAttribute('data-gallery-autoplay')) return;
      stopAutoplay(gallery);
      const state = autoplayState.get(gallery) || {};
      clearTimeout(state.resumeTimer);
      state.resumeTimer = setTimeout(() => startAutoplay(gallery), 1800);
      autoplayState.set(gallery, state);
    };

    document.addEventListener('click', (e) => {
      const gallery = e.target.closest('[data-product-gallery]');
      if (!gallery) return;

      const prevBtn = e.target.closest('[data-gallery-prev]');
      const nextBtn = e.target.closest('[data-gallery-next]');
      const dotBtn = e.target.closest('[data-gallery-dot]');
      const thumbBtn = e.target.closest('[data-gallery-thumb]');
      if (!prevBtn && !nextBtn && !dotBtn && !thumbBtn) return;

      e.preventDefault();
      e.stopPropagation();

      if (prevBtn) {
        const count = slideCount(gallery);
        goTo(gallery, (currentIndex(gallery) - 1 + count) % count);
      } else if (nextBtn) {
        goTo(gallery, (currentIndex(gallery) + 1) % slideCount(gallery));
      } else if (dotBtn) {
        goTo(gallery, getDots(gallery).indexOf(dotBtn));
      } else if (thumbBtn) {
        goTo(gallery, getThumbs(gallery).indexOf(thumbBtn));
      }

      restartAutoplayLater(gallery);
    });

    document.addEventListener('mousemove', (e) => {
      const zoom = e.target.closest('[data-gallery-zoom]');
      if (!zoom) return;
      const img = zoom.querySelector('img');
      if (!img) return;
      const rect = zoom.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = `${x}% ${y}%`;
    });

    document.addEventListener('mouseout', (e) => {
      const zoom = e.target.closest('[data-gallery-zoom]');
      if (!zoom) return;
      const img = zoom.querySelector('img');
      if (img) img.style.transformOrigin = '50% 50%';
    });

    const observed = new WeakSet();
    const initGallery = (gallery) => {
      if (observed.has(gallery)) return;
      observed.add(gallery);

      if (!isThumbMode(gallery)) {
        const track = gallery.querySelector('[data-gallery-track]');
        const dots = getDots(gallery);
        const slides = track ? [...track.children] : [];
        if (track && dots.length && slides.length) {
          const io = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                const idx = slides.indexOf(entry.target);
                dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
              });
            },
            { root: track, threshold: 0.6 }
          );
          slides.forEach((s) => io.observe(s));
        }
      }

      gallery.addEventListener('mouseenter', () => stopAutoplay(gallery));
      gallery.addEventListener('mouseleave', () => restartAutoplayLater(gallery));
      gallery.addEventListener('touchstart', () => stopAutoplay(gallery), { passive: true });
      gallery.addEventListener('touchend', () => restartAutoplayLater(gallery), { passive: true });

      if (gallery.hasAttribute('data-gallery-autoplay')) {
        const visibilityIO = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                startAutoplay(gallery);
              } else {
                stopAutoplay(gallery);
              }
            });
          },
          { threshold: 0.2 }
        );
        visibilityIO.observe(gallery);
      }
    };

    document.querySelectorAll('[data-product-gallery]').forEach(initGallery);

    document.addEventListener('gallery:init', (e) => {
      if (e.target && e.target.matches && e.target.matches('[data-product-gallery]')) {
        initGallery(e.target);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-view-modal"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('[data-quick-view]').forEach((dialog) => {
      dialog.addEventListener('click', (e) => {
        if (e.target === dialog) dialog.close();
      });

      const variantSelect = dialog.querySelector('[data-quick-view-variant]');
      const addBtn = dialog.querySelector('[data-quick-view-add]');
      const priceEl = dialog.querySelector('[data-quick-view-price]');

      if (variantSelect && addBtn) {
        variantSelect.addEventListener('change', () => {
          const opt = variantSelect.selectedOptions[0];
          if (!opt) return;
          addBtn.dataset.variantId = opt.value;
          const available = opt.dataset.available === 'true';
          addBtn.disabled = !available;
          addBtn.querySelector('.quick-view__add-label').textContent = available ? 'Sepete ekle' : 'Tükendi';
          if (priceEl) {
            const compare = opt.dataset.compare;
            const price = opt.dataset.price;
            priceEl.innerHTML =
              compare && compare !== price
                ? `<span class="quick-view__price-compare">${compare}</span><span class="quick-view__price-sale">${price}</span>`
                : `<span>${price}</span>`;
          }
        });
      }

      const qtyWrap = dialog.querySelector('[data-quick-view-qty]');
      if (qtyWrap) {
        const input = qtyWrap.querySelector('[data-qty-input]');
        qtyWrap.querySelector('[data-qty-increase]').addEventListener('click', () => {
          input.value = Math.min(99, (parseInt(input.value, 10) || 1) + 1);
        });
        qtyWrap.querySelector('[data-qty-decrease]').addEventListener('click', () => {
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        });
      }

      if (addBtn) {
        addBtn.addEventListener('click', async () => {
          const variantId = parseInt(addBtn.dataset.variantId, 10);
          if (!variantId) return;
          const qtyInput = qtyWrap && qtyWrap.querySelector('[data-qty-input]');
          const quantity = parseInt(qtyInput && qtyInput.value, 10) || 1;
          addBtn.disabled = true;
          const img = dialog.querySelector('.product-gallery__slide img');
          document.dispatchEvent(new CustomEvent('cart:fly', { detail: { sourceEl: img } }));
          try {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
            });
            addBtn.classList.add('is-added');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(() => addBtn.classList.remove('is-added'), 2200);
          } catch (err) {}
          addBtn.disabled = false;
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-actions"] && !Shopify.designMode) return;
  try {
    (() => {
    const btn = document.querySelector('[data-scroll-top]');
    if (!btn) return;
    btn.hidden = false;

    const toggle = () => {
      btn.classList.toggle('is-visible', window.scrollY > 500);
    };
    window.addEventListener('scroll', toggle, { passive: true });
    toggle();

    btn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
